import { render, staticRenderFns } from "./LeavesListApproved.vue?vue&type=template&id=ed50096c&scoped=true"
import script from "./LeavesListApproved.vue?vue&type=script&lang=js"
export * from "./LeavesListApproved.vue?vue&type=script&lang=js"
import style0 from "./LeavesListApproved.vue?vue&type=style&index=0&id=ed50096c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed50096c",
  null
  
)

export default component.exports